module.exports = __webpack_public_path__ + "img/identify05.8df0c0f6.jpg";